import React, { useState }          from 'react';
import { historyPropType }          from '~/config/routerPropTypes';
import {
  createSubscription,
  showSubscription
}                                   from '~/config/routes';
import Request                      from '~/providers/Request';
import SubscriptionRecord           from '~/records/SubscriptionRecord';
import Form                         from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new SubscriptionRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    const data = record.toParams();
    setLoading(true);
    Request.post('/admin/plans', data, {}, { controller: 'subscription' })
    .then((resp) => {
      setLoading(false);
      if(saveAndContinue){
        history.push(createSubscription.reverse());
      } else{
        history.push(showSubscription.reverse(resp.data));
      }
    }).catch((err) => {
      console.error(err);
      setLoading(false);
    } );
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
